<template>
  <div class="page" style="overflow: auto;">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="upload-body">
      <span style="font-weight: bold; font-size: 25px;">Upload Data</span>
      <el-divider />
      <span style="font-weight: bold; font-size: 18px; margin-left:30px;">In order to annotate, data first needs to be uploaded.</span>
      <ul>
        <li>Upload text to be annotated, support CSV/TXT/JSON formats</li>
      </ul>
      <el-container>
      <el-upload
        ref="uploadCSV"
        class="upload-demo"
        action=""
        :show-file-list="true"
        :limit="1"
        :before-upload="beforeUploadCSV"
        :on-exceed="handleExceed"
        :on-change="handlePreviewCSV"
        :auto-upload="false"
        :file-list="fileListCSV"
        :on-remove="deleteCSV"
      >
        <template #trigger>
          <el-button type="primary" style="width: 350px; margin-bottom: 20px;">
            <el-icon :size="20"><DocumentAdd /></el-icon>Please choose a CSV/TXT/JSON document...
          </el-button>
        </template>
<!--        上传的Text数据预览部分-->
        <el-table
            :data="Object.values(previewData.rows).map(text => ({ text }))"
            style="width: 100%"
            v-if="previewData.rows"
        >
          <el-table-column
              prop="text"
              label="Preview Text"
          >
          </el-table-column>
        </el-table>


        <el-form :model="cleaningOptions" class="cleaning-form">
          <div class="cleaning-form-row">
            <el-checkbox v-model="cleaningOptions.remove_punctuation">Punctuation Cleaning</el-checkbox>
            <el-input v-model="cleaningOptions.preserved_punctuation" placeholder="Please enter the punctuation to be retained" style="width: 300px;"></el-input>
          </div>
          <div class="cleaning-form-row">
            <el-checkbox v-model="cleaningOptions.remove_html_tags">Removing HTML tags</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_urls">Removing URLs</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_emojis">Removing emoji</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_extra_spaces">Removing space</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_newlines_and_tabs">Removing \n and \t</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_title_brackets">Removing title</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_emotion_brackets">Removing twitter emoji</el-checkbox>
            <el-checkbox v-model="cleaningOptions.remove_hashtags">Removing #（hashtag）</el-checkbox>
          </div>
        </el-form>
        <el-button class="ml-3" type="success" style="width:250px;" @click="submitUploadCSV"><el-icon :size="20"><UploadFilled /></el-icon>
          Confirm uploaded annotation data
        </el-button>
      </el-upload>
      &nbsp;&nbsp;&nbsp;&nbsp;
      </el-container>
      <br/>
      <ul>
        <li>Upload ontology models, support OWL format</li>
      </ul>
      <el-container>
      <el-upload
        ref="uploadOWL"
        class="upload-demo"
        action=""
        :show-file-list="true"
        :limit="1"
        :before-upload="beforeUploadOWL"
        :on-exceed="handleExceed"
        :auto-upload="false"
        :file-list="fileListOWL"
      >
        <template #trigger>
          <el-button type="primary" style="width:250px;"><el-icon :size="20"><DocumentAdd /></el-icon>Please choose an OWL document...</el-button>
        </template>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:250px;" @click="submitUploadOWL"><el-icon :size="20"><UploadFilled /></el-icon>
          Confirm uploaded ontology
        </el-button>
      </el-upload>

      <!-- <el-input v-model="nameOWL" placeholder="请Upload Data" disabled = "true" style="width:250px; height: 35px;"></el-input>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button circle type="danger" @click="deleteOWL"><el-icon :size="15"><Delete /></el-icon></el-button> -->
      </el-container>
<!--      <el-button class="ml-3" type="success" style="width:250px;" @click="choiceLabel"><el-icon :size="20"><UploadFilled /></el-icon>-->
<!--          从系统导入本体模型标签-->
<!--      </el-button>-->

      <ul>
        <li>Upload entity dictionary, support JSON format</li>
      </ul>
      <el-container>
      <el-upload
        ref="uploadJSON"
        class="upload-demo"
        action=""
        :show-file-list="true"
        :limit="1"
        :before-upload="beforeUploadJSON"
        :on-exceed="handleExceed"
        :auto-upload="false"
        :file-list="fileListJSON"
        :on-progress="progressJson"
      >
        <template #trigger>
          <el-button type="primary" style="width:250px;"><el-icon :size="20"><DocumentAdd /></el-icon>Please choose a JSON document...</el-button>
        </template>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:250px;" @click="submitUploadJSON"><el-icon :size="20"><UploadFilled /></el-icon>
          Confirm uploaded entity dictionary
        </el-button>
      </el-upload>
      <!-- <el-input v-model="nameJSON" placeholder="请Upload Data" disabled = "true" style="width:250px; height: 35px;"></el-input>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <el-button circle type="danger" @click="deleteJSON"><el-icon :size="15"><Delete /></el-icon></el-button> -->
      </el-container>
      <br />
      <ul>
        <li>Upload rules dictionary, support JSON format</li>
      </ul>
      <el-upload
        ref="uploadRULE"
        class="upload-demo"
        action=""
        :show-file-list="true"
        :limit="1"
        :before-upload="beforeUploadRULE"
        :on-exceed="handleExceed"
        :auto-upload="false"
        :file-list="fileListRule"
      >
        <template #trigger>
          <el-button type="primary" style="width:250px;"><el-icon :size="20"><DocumentAdd /></el-icon>Please choose a JSON document...</el-button>
        </template>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button class="ml-3" type="success" style="width:250px;" @click="submitUploadRULE"><el-icon :size="20"><UploadFilled /></el-icon>
          Confirm uploaded rule dictionary
        </el-button>
      </el-upload>
    </el-card>
    <!-- <el-backtop class="wow bounceInRight"/> -->
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
// import NavigatorMenuMobile from "../components/NavigatorMenuMobile";
import WOW from "wow.js";
import axios from 'axios';
export default {
  name: "UploadPage",
  components: {
  //   AdvSearch,
  //   NavigatorMenuMobile,
    NavigatorMenu,
  //   Edit,
  //   Swiper
  },
  data(){
    return{
      csrfToken:'',
      url:'',
      user_id:'',
      project_id: this.$route.params.project_id,
      fileListCSV:[{name: 'food.jpeg'}],
      fileListOWL:[{name: 'food1.jpeg'}],
      fileListJSON:[{name: 'food2.jpeg'}],
      fileListRule:[{name: 'food3.jpeg'}],
      previewData:[{rows: []}],
      cleaningOptions: {
        remove_punctuation: false,
        preserved_punctuation: '',
        remove_html_tags: false,
        remove_urls: false,
        remove_emojis: false,
        remove_newlines_and_tabs: false,
        remove_title_brackets: false,
        remove_emotion_brackets: false,
        remove_hashtags: false,
        remove_extra_spaces: false
      },
      nameCSV:'',
      nameOWL:'',
      nameJSON:'',
      nameRule:'',
      searchWord: '',
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    console.log(this.$route.params.project_id)
    // 生成csrftoken
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    this.getUser()
    this.fileListCSV = [];
    this.fileListOWL = [];
    this.fileListJSON = [];
    this.fileListRule = [];
  },
  watch:{
    fileListCSV:{
      handler(){
        if (this.fileListCSV.length == 1){
          var fileCSV = this.fileListCSV[0];
          this.nameCSV = fileCSV.name;
        }
        else{
          this.nameCSV = '';
        }
      },
      deep:true
    },
    fileListOWL:{
      handler(){
        if (this.fileListOWL.length == 1){
          var fileOWL = this.fileListOWL[0];
          this.nameOWL = fileOWL.name;
        }
        else{
          this.nameOWL = '';
        }
      },
      deep:true
    },
    fileListJSON:{
      handler(){
        if (this.fileListJSON.length == 1){
          var fileJSON = this.fileListJSON[0];
          this.nameJSON = fileJSON.name;
        }
        else{
          this.nameJSON = '';
        }
      },
      deep:true
    },
    fileListRule:{
      handler(){
        if (this.fileListRule.length == 1){
          var fileRULE = this.fileListRule[0];
          this.nameRule = fileRULE.name;
        }
        else{
          this.nameRule = '';
        }
      },
      deep:true
    }
  },
  mounted() {
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    console.log(wow)
    wow.init();
    // this.echartinit();
  },
  methods: {
    getUser(){
      // 获取当前用户
      axios({
        method: 'get',
        url: '/api/user',
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if (response.status == 200) {
          console.log(response)
          this.user_id = response.data.user_id
          console.log(this.user_id)
        }
      }).catch(error=>{
        console.log('error')
        console.log(error)
      })
    },
    choiceLabel(){
      console.log("开始等待选择标签")
       var data = new Object();
       data.project_id = this.project_id;
       console.log(data);
       axios({
          method: 'get',
          url: 'api/openapi/getUrl',
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
        }).then(response => {
          if (response.status == 200) {
            this.url = response.data
            this.url = "dgraph.askgraph.top" // 这里需要根据不同的系统前端做出调整!!
            console.log('http://'+this.url+"/Workbench")
            window.parent.postMessage(data,'http://'+this.url+"/Workbench")
            console.log(window.location.href.split('/').slice(0, 5).join('/') +"/labels")
            window.location.href = window.location.href.split('/').slice(0, 5).join('/') +"/labels"
            console.log("chioce ok")
          }
        }).catch(error=>{
          console.log('error')
          console.log(error)
        })

    },
    beforeUploadCSV(fileName) {
      //判断文件类型，必须是csv/txt格式
      console.log(fileName.type);
      const isCSV = fileName.type === 'text/csv';
      const isTXT = fileName.type === 'text/plain';
      const isJSON = fileName.type === 'application/json';
      const isPDF = fileName.type === 'application/pdf';
      const isDocx = fileName.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      if (!isCSV && !isTXT && !isJSON && !isDocx && !isPDF ) {
        this.$message.error('Upload Data只能是 CSV/TXT/JSON/docx/PDF 格式!');
        return false;
      }
      let data = new FormData();
      data.append('file',fileName); // 添加文件
      data.append('options',JSON.stringify(this.cleaningOptions)); // 添加选项
      axios({
        method: 'post',
        url: '/api/api/projects/upload/' + this.project_id + '/'+ this.user_id + '/csv',
        data,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        // console.log('response:')
        // console.log(response)
        if (response.status == 200) {
          window.alert('Upload Success')
          console.log("Upload Success")
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
      return true;
    },
    beforeUploadOWL(fileName) {
      //判断文件类型，必须是owl格式
      console.log(fileName);
      var fileTypeList = fileName.name.split('.');
      console.log(fileTypeList);
      var fileType = fileTypeList[1];
      console.log(fileType);
      const isOWL = fileType === 'owl';
      if (!isOWL) {
        window.alert('Upload Data只能是 OWL 格式!');
        return false;
      }
      let data = new FormData();
      data.append('file',fileName);
      axios({
        method: 'post',
        url: '/api/api/projects/upload/' + this.project_id + '/'+ this.user_id + '/owl',
        data,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        // console.log('response:')
        // console.log(response)
        if (response.status == 200) {
          window.alert('Upload Success')
          console.log("Upload Success")
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
      return true;
    },
    beforeUploadJSON(fileName) {
      //判断文件类型，必须是JSON格式
      console.log(fileName.type);
      const isJSON = fileName.type === 'application/json';

      if (!isJSON) {
        window.alert('Upload Data只能是 JSON 格式!');
        return false;
      }
      let data = new FormData();
      data.append('file',fileName);
      axios({
        method: 'post',
        url: '/api/api/projects/upload/' + this.project_id + '/'+ this.user_id + '/dict',
        data,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if (response.status == 200) {
          console.log("Upload Success")
          window.alert('Upload Success')
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
      return true;
    },
    beforeUploadRULE(fileName) {
      //判断文件类型，必须是JSON格式
      console.log(fileName.type);
      const isJSON = fileName.type === 'application/json';

      if (!isJSON) {
        window.alert('Upload Data只能是 JSON 格式!');
        return false;
      }
      let data = new FormData();
      data.append('file',fileName);
      axios({
        method: 'post',
        url: '/api/api/projects/upload/' + this.project_id + '/'+ this.user_id + '/rule',
        data,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        if (response.status == 200) {
          console.log("Upload Success")
          window.alert('Upload Success')
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
      return true;
    },
    handleExceed() {
      window.alert('最多支持1个附件上传')
    },
    submitUploadCSV(){
      this.$refs.uploadCSV.submit();
      this.previewData = [{rows: []}]; // 上传后清空预览数据
    },
    submitUploadOWL(){
      this.$refs.uploadOWL.submit();
    },
    submitUploadJSON(){
      this.$refs.uploadJSON.submit();
      // this.$refs.uploadJSON.clearFiles();
    },
    submitUploadRULE(){
      this.$refs.uploadRULE.submit();
      // this.$refs.uploadJSON.clearFiles();
    },
    handlePreviewCSV(fileName) {
      // 发送第一次POST请求，用于预览
      console.log(fileName)
      let data = new FormData();
      data.append('file',fileName.raw); // 添加文件
      axios({
        method: 'post',
        url: '/api/api/projects/upload/' + this.project_id + '/'+ this.user_id + '/preview',
        data,
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        // console.log('response:')
        // console.log(response)
        if (response.status === 200) {
          console.log(response)
          this.previewData = response.data
          console.log(this.previewData)
          console.log(this.previewData.rows)

        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
      return true;
    },
    deleteCSV(){
      this.fileListCSV = [];
      this.previewData = [{rows: []}]; // 上传后清空预览数据
    },
    deleteOWL(){
      this.fileListOWL = [];
    },
    deleteJSON(){
      this.fileListJSON = [];
    },
    deleteRULE(){
      this.fileListRule = [];
    }
  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.upload-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 100%;
  width: 75%;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.7);
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
.cleaning-form-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.el-upload-list__item-file-name {
  font-size :18px;
}
</style>